<template>
<v-container>
  <v-card outlined class="px-2 py-2 rounded-xl">
    <!-- {{baseUrl}} -->
    <v-data-table :loading="load" :headers="headers" :items="desserts" sort-by="idAnuncio" class="rounded-xl">
      <template v-slot:item.ativo="{ item }">
        <v-simple-checkbox :input-value="item.ativo? true: false" v-model="item.ativo" disabled></v-simple-checkbox>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Anúncios</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog persistent v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="novoAnuncio" color="primary" dark :loading="load" rounded class="mb-2" v-bind="attrs" v-on="on">
                Novo Anuncio
              </v-btn>
            </template>
            <v-card :disabled="load">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                     <v-col cols="9" sm="9" md="9">
                      <v-select @change="changeTipo" v-model="editedItem.tipo" :items="midias" label="Tipo de mídia" />
                    </v-col>
                     <v-col cols="3" sm="3" md="3">
                      <v-checkbox :disabled="!editedItem.tipo" v-model="editedItem.ativo" :true-value="1" :false-value="0" label="Ativo" />
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field :disabled="!editedItem.tipo" v-model="editedItem.nome" label="Nome"></v-text-field>
                    </v-col>

                    <v-col v-if="editedItem.tipo === 'video'" cols="8" sm="8" md="8">
                      <v-text-field  v-model="editedItem.link" label="Link"></v-text-field>
                    </v-col>

                    <v-col v-if="editedItem.tipo === 'video'" cols="4" sm="4" md="4">
                      <v-text-field  v-model="editedItem.intervaloReproducao" label="Intervalo de reprodução"></v-text-field>
                    </v-col>

                    <v-col class="pb-0 mb-0 d-flex flex-column align-center" cols="12" sm="12" md="12" v-if="editedItem.tipo === 'imagem'">
                        <v-img v-if="imageUrl === ''"  max-height="150" max-width="250" :src="`${baseUrl}${editedItem.link}?token=${token}`" />
                        <v-img v-if="imageUrl"  max-height="150" max-width="250" :src="imageUrl" />
                    </v-col>
                    <v-col class="pt-0" cols="12" sm="12" md="12" v-if="editedItem.tipo === 'imagem'">
                        <v-text-field readonly label="Selecionar imagem" @click="pickFile" v-model="imageName" prepend-icon="attach_file"></v-text-field>
                        <input type="file" name="sampleFile" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text :loading="load" @click="save">
                  Salvar
                </v-btn>
              </v-card-actions>
              <v-alert v-show="msg" dense class="mx-2 mb-2" outlined type="error">
                {{msg}}
              </v-alert>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Tem certeza de que deseja excluir este item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Não</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">Sim</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.link="{ item }">

        <div v-if="item.tipo == 'imagem'">
          <!-- {{`${baseUrl}administradorUnidade/${item.link}?token=${token}`}} -->
          <v-img class="my-1" max-height="150" max-width="250" :src="`${baseUrl}administradorUnidade/${item.link}?token=${token}`" />
        </div>
        <div v-if="item.tipo == 'video'">
          {{item.link}}
        </div>

        <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon> -->
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary">
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import {
  getToken
} from '../../../store/auth'
import {
  baseURL
} from '../../../services/config'
import axios from 'axios'

export default {
  name: 'listarAnuncios',
  data () {
    return {
      list: [],
      dialog: false,
      dialogDelete: false,
      user: '',
      baseUrl: baseURL,
      token: getToken(),
      load: false,
      uploadPercentage: 0,
      msg: '',
      imageName: '',
      imageFile: '',
      imageUrl: '',
      midias: ['video', 'imagem'],
      headers: [{
        text: 'Id',
        value: 'idAnuncio'
      },
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      {
        text: 'Intervalo de reprodução (min)',
        value: 'intervaloReproducao'
      },
      {
        text: 'Link',
        value: 'link'
      },
      {
        text: 'Tipo de mídia',
        value: 'tipo'
      },
      {
        text: 'Ativo',
        value: 'ativo'
      },
      {
        text: 'Editar',
        value: 'actions',
        sortable: false
      }

      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        idAnuncio: '',
        nome: '',
        link: '',
        intervaloReproducao: '',
        tipo: '',
        ativo: 0
      },
      defaultItem: {
        idAnuncio: '',
        nome: '',
        link: '',
        intervaloReproducao: '',
        tipo: '',
        ativo: 0
      }
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Anuncio' : 'Editar Anuncio'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    msg (val) {
      setTimeout(() => {
        this.msg = ''
      }, 5000)
    }
  },

  mounted () {
    this.user = this.$store.getters.usuario
    this.listarAnuncios()
  },
  methods: {
    novoAnuncio () {
      this.editedItem = { idAnuncio: '',
        nome: '',
        link: '',
        intervaloReproducao: '',
        tipo: '',
        ativo: 0 }
    },
    changeTipo (val) {
      if (val === 'video') {
        this.imageName = this.editedItem.link
        this.editedItem.link = ''
      } else if (this.imageName) {
        // this.imageName = this.editedItem.link
        this.editedItem.link = this.imageName
      }
    },
    pickFile () {
      this.$refs.image.click()
    },
    listarAnuncios () {
      this.load = true
      administradorUnidadeService.administradorUnidade.retornarAnuncios().then(r => {
        if (r.status == 200) {
          this.desserts = r.data
        }
      }).finally(() => {
        this.load = false
      })
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.desserts.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.imageUrl = ''
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      this.load = true
      // let formData = null
      // if (this.editedItem.tipo === 'imagem') {
      let formData = new FormData()
      formData.append('nome', this.editedItem.nome)
      formData.append('idAnuncio', this.editedItem.idAnuncio)
      formData.append('link', this.editedItem.link)
      formData.append('intervaloReproducao', this.editedItem.intervaloReproducao)
      formData.append('tipo', this.editedItem.tipo)
      formData.append('ativo', this.editedItem.ativo)
      formData.append('imagem', this.imageFile)

      // this.fileUpload(formData).then(r => {
      //   this.imageName = "";
      //   this.imageFile = "";
      //   this.imageUrl = "";
      //   // this.uploadPercentage = 0,
      // }).catch(function () {

      // });

      if (this.editedItem.idAnuncio !== '') {
        this.fileEditUpload(formData).then(r => {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
          this.desserts = []
          this.listarAnuncios()
          this.close()
          this.uploadPercentage = 0

          // this.carregarNoticias()
        }).catch(function () {

        })
        // administradorUnidadeService.administradorUnidade.alterarAnuncio(formData).then(r => {
        //   if (r.status == 200 && r.data == true) {
        //     this.desserts = []
        //     this.listarAnuncios()
        //     this.close()
        //   } else {
        //     this.msg = 'Erro ao editar o anúncio'
        //   }
        // }).finally(() => {
        //   this.load = false
        // })
      } else {
        formData.append('idEmpresa', this.user.idEmpresa)
        this.fileUpload(formData).then(r => {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
          this.desserts = []
          this.listarAnuncios()
          this.close()
          this.uploadPercentage = 0

          // this.carregarNoticias()
        }).catch(function () {

        })
        // this.editedItem.idEmpresa = this.user.idEmpresa
        // administradorUnidadeService.administradorUnidade.cadastrarAnuncio(formData).then(r => {
        //   if (r.status == 200 && r.data == true) {
        //     this.desserts = []
        //     this.listarAnuncios()
        //     this.close()
        //   } else {
        //     this.msg = 'Erro ao cadastrar o anúncio'
        //   }
        // }).finally(() => {
        //   this.load = false
        // })
      }
    },
    fileEditUpload (data) {
      var http = axios.create({
        // baseURL: 'http://localhost:8484/lapison/rest/'
        // 191.252.200.167:3000
        baseURL: baseURL
        // baseURL: 'http://191.252.200.167:3000/'
      })
      console.log(data, baseURL)
      return http.post(`/administradorUnidade/alterarAnuncio`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': this.token
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this)
      }).finally(() => {})
    },
    fileUpload (data) {
      var http = axios.create({
        // baseURL: 'http://localhost:8484/lapison/rest/'
        // 191.252.200.167:3000
        baseURL: baseURL
        // baseURL: 'http://191.252.200.167:3000/'
      })
      console.log(data, baseURL)
      return http.post(`/administradorUnidade/cadastrarAnuncio`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': this.token
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this)
      }).finally(() => {})
    }
  }
}
</script>
